export const numberOnly = (event: any): boolean => {
  const charCode = event.which ? event.which : event.keyCode;

  if (charCode === 8 || charCode === 46) {
    return true;
  }
  // Only Numbers 0-9
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
    return false;
  } else {
    return true;
  }
};

export const numberOnlyWithCallback =
  (callback: any) =>
  (event: any): boolean => {
    const charCode = event.which ? event.which : event.keyCode;
    if (!callback(event)) return false;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  };

export const checkPasswordStrength = (password: string) => {
  // Define regex patterns for different criteria
  const patterns: { [key: string]: any } = {
    length: /.{8,}/,
    lowercase: /[a-z]/,
    uppercase: /[A-Z]/,
    numeric: /\d/,
    special: /[$&+,:;=?@#|'<>.^*()%!-]/,
  };

  // Initialize score and criteria count
  let score = 0;
  let criteriaResults: { [key: string]: any } = {};

  // Check each criteria and update the score accordingly
  for (const pattern in patterns) {
    criteriaResults[pattern] = patterns[pattern].test(password);
    if (criteriaResults[pattern]) {
      score += 1;
    }
  }

  let pass = true;
  // Bonus points for meeting multiple criteria
  const criteriaCount: number = Object.values(criteriaResults).filter(
    (result) => {
      if (!result) {
        pass = false;
      }
      return result === true;
    }
  ).length;
  if (criteriaCount > 3) {
    score += 1;
  }

  // Determine strength based on score
  let strength: string;
  if (score < 3) {
    strength = "Weak";
  } else if (score < 5) {
    strength = "Moderate";
  } else {
    strength = "Strong";
  }

  return { strength, criteriaResults, pass, criteriaCount };
};

export const inputEventMock = (value: any) => {
  return {
    preventDefault: () => {},
    target: { value },
  };
};
